
function InputToggleController() {
    var ctrl = this;

    this.$onInit = function () {
        this.size = 22;
    };

    /*
    this.$onChanges = function (changes) {
        console.log('Size changed ' + this.size);
        console.log(changes);
    };
    */

    ctrl.toggleOption = function () {
        ctrl.ngModel = !ctrl.ngModel;
        ctrl.ngChange();
    };

    
}

seedWebApp.component('sdInputToggle', {
    controller: InputToggleController,
    bindings: {
        ngModel: '=',
        ngChange: '&'
    },
    templateUrl: './SPA/components/sd-input-toggle.html'
});